import React, { Component } from "react";

class Navbar extends Component {
  render() {
    return (
      <div>
        <nav className="navbar navbar-expand-lg bg-light fixed-top shadow-lg">
          <div className="container">
            <a className="navbar-brand mx-auto d-lg-none"  >
              Medic Care
              <strong className="d-block">Health Specialist</strong>
            </a>

            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav mx-auto">
                

                <li className="nav-item">
                  <a className="nav-link" href="#about">
                    About
                  </a>
                </li>

                <li className="nav-item">
                  <a className="nav-link" href="#timeline">
                    Services
                  </a>
                </li>

                <a className="navbar-brand d-none d-lg-block"  >
                  Elixir
               
                </a>

                <li className="nav-item">
                  <a className="nav-link" href="/login">
                    Login
                  </a>
                </li>

                <li className="nav-item">
                  <a className="nav-link" href="/register">
                    Sign Up
                  </a>
                </li>

               
              </ul>
            </div>
          </div>
        </nav>
      </div>
    );
  }
}

export default Navbar;
